module.exports = __webpack_public_path__ + "img/logo-circle.7e333a8f.svg";